export let IdentityVerificationMethod;

(function (IdentityVerificationMethod) {
  IdentityVerificationMethod["GoogleVerification"] = "google-verification";
  IdentityVerificationMethod["EmailVerification"] = "email-verification";
  IdentityVerificationMethod["CodeVerification"] = "code-verification";
  IdentityVerificationMethod["MicrosoftVerification"] = "microsoft-verification";
})(IdentityVerificationMethod || (IdentityVerificationMethod = {}));